import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useRef, useEffect, isValidElement, Children, cloneElement } from 'react';
import { isForwardRef } from 'react-is';
import { useMergeRefs } from 'use-callback-ref';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '@popperjs/core';
import { useHover } from '../../hooks/useHover/useHover.es.js';
import { useUpdateEffect } from '../../hooks/useUpdateEffect/useUpdateEffect.es.js';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import { Popper } from '../../primitives/Popper/Popper.es.js';
import { Fade } from '../Fade/Fade.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { Tooltip as Tooltip$1, Content } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var TooltipComponent = function TooltipComponent(_a) {
  var _b = _a,
      _b$hasArrow = _b.hasArrow,
      hasArrow = _b$hasArrow === void 0 ? true : _b$hasArrow,
      _b$maxWidth = _b.maxWidth,
      maxWidth = _b$maxWidth === void 0 ? "240px" : _b$maxWidth,
      _b$fontSize = _b.fontSize,
      fontSize = _b$fontSize === void 0 ? "xs" : _b$fontSize,
      _b$position = _b.position,
      position = _b$position === void 0 ? "top" : _b$position,
      _b$isInverted = _b.isInverted,
      isInverted = _b$isInverted === void 0 ? false : _b$isInverted,
      _b$hideOnScroll = _b.hideOnScroll,
      hideOnScroll = _b$hideOnScroll === void 0 ? false : _b$hideOnScroll,
      children = _b.children,
      content = _b.content,
      onOpen = _b.onOpen,
      onClose = _b.onClose,
      props = __objRest(_b, ["hasArrow", "maxWidth", "fontSize", "position", "isInverted", "hideOnScroll", "children", "content", "onOpen", "onClose"]);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useHover = useHover(hideOnScroll),
      hoverRef = _useHover[0],
      isHovered = _useHover[1];

  var popperRef = useRef(null);
  var mergedRefs = useMergeRefs([hoverRef, children.ref]);
  useOnClickOutside(popperRef, function () {
    setOpen(false);
  });
  useEffect(function () {
    setOpen(isHovered);
  }, [isHovered]);
  useUpdateEffect(function () {
    open ? onOpen == null ? void 0 : onOpen() : onClose == null ? void 0 : onClose();
  }, [open]);
  var childrenProps = {
    ref: mergedRefs
  };
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    isValidElement(children) && Children.only(children) && isForwardRef(children) ?
    /*#__PURE__*/
    cloneElement(children, __spreadValues(__spreadValues({}, props), childrenProps)) :
    /* @__PURE__ */
    React.createElement(Box, {
      display: "inline-flex",
      ref: hoverRef
    },
    /*#__PURE__*/
    isValidElement(children) &&
    /*#__PURE__*/
    cloneElement(children, __spreadValues({}, props))),
    /* @__PURE__ */
    React.createElement(Popper, {
      isOpen: !!content && open,
      ref: popperRef,
      anchorRef: hoverRef,
      transitionComponent: Fade,
      usePortal: true,
      popperOptions: {
        placement: position,
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, 10]
          }
        }]
      },
      zIndex: 2e3
    },
    /* @__PURE__ */
    React.createElement(Tooltip$1, {
      isInverted: isInverted,
      maxWidth: maxWidth
    },
    /* @__PURE__ */
    React.createElement(Content, {
      size: fontSize
    }, content), hasArrow &&
    /* @__PURE__ */
    React.createElement(Popper.Arrow, null))))
  );
};

var TooltipAdoptedForMobile = function TooltipAdoptedForMobile(_c) {
  var _d = _c,
      children = _d.children,
      props = __objRest(_d, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(TooltipComponent, __spreadValues({}, props), children)
  );
};

var Tooltip = maestroComponent("Tooltip", TooltipAdoptedForMobile);
export { Tooltip };